<div *ngIf="value != null" class="container">

    <div *ngIf="routePartCMR == null">
        <div class="block-title">
            <div class="title">{{ getResourceControlDocument() | translate }}</div>
        </div>

        <div *ngFor="let cmr of value" class="action-card card-documents" (click)="onClickLinkCMR(cmr)">
            <div class="icon-wrapper">
                <i class="fa fa-file-text" aria-hidden="true"></i>
            </div>
            <div class="card-body">
                <div class="card-title">{{ cmr.originTenantName }} {{ cmr.originTenantFormattedAddress }}</div>
                <div class="card-title">{{ cmr.destinationTenantName }} {{ cmr.destinationTenantFormattedAddress }}</div>
            </div>
            <i class="fa fa-chevron-right arrow-right" aria-hidden="true"></i>
        </div>
    </div>
    <shared-route-part-cmr-document-component *ngIf="routePartCMR != null" class="hideincomplet" [avoidOptionFirma]="true"
        [external]="true" [value]="routePartCMR" (dataRefresh)="onDocumentValueChanged()">
    </shared-route-part-cmr-document-component>

    <div class="dummy"></div>
</div>